import ROUTES from '../routes';
import NewApplication from '../hoc/new-application/new-application';
import NewApplcationList from '../hoc/new-application/list';
import NewApplicationIndividualInfo from '../hoc/new-application/individual/info';
import NewApplicationCorporateInfo from '../hoc/new-application/corporate/info';
import NewApplicationMainRepresentativeInfo from '../hoc/new-application/main-representative/info';
import CorporateDocumentSidepanel from '../hoc/new-application/corporate/document';
import IndividualDocumentSidepanel from '../hoc/new-application/individual/document';
import CofDocumentSidepanel from '../hoc/new-application/main-representative/document';
import ApplicationAgreement from '../hoc/new-application/agreement/agreement-sidepanel';
import { ApplicationType } from '../hoc/new-application/types';

const NewAppliation = {
  path: ROUTES.CUSTOMERS_NEW_APPLICATION,
  element: <NewApplication />,
  children: [
    {
      path: ROUTES.CUSTOMERS_NEW_APPLICATION_LIST,
      element: <NewApplcationList />,
    },
    {
      path: ROUTES.CUSTOMERS_NEW_APPLICATION_INDIVIDUAL_INFO,
      element: <NewApplicationIndividualInfo />,
      children: [
        {
          path: ROUTES.CUSTOMERS_NEW_APPLICATION_INDIVIDUAL_AGREEMENT,
          element: (
            <ApplicationAgreement
              applicationType={ApplicationType.INDIVIDUAL}
            />
          ),
        },
        {
          path: ROUTES.CUSTOMERS_NEW_APPLICATION_INDIVIDUAL_DOCUMENT,
          element: <IndividualDocumentSidepanel />,
        },
      ],
    },
    {
      path: ROUTES.CUSTOMERS_NEW_APPLICATION_CORPORATE_INFO,
      element: <NewApplicationCorporateInfo />,
      children: [
        {
          path: ROUTES.CUSTOMERS_NEW_APPLICATION_CORPORATE_AGREEMENT,
          element: (
            <ApplicationAgreement applicationType={ApplicationType.CORPORATE} />
          ),
        },
        {
          path: ROUTES.CUSTOMERS_NEW_APPLICATION_CORPORATE_DOCUMENT,
          element: <CorporateDocumentSidepanel />,
        },
      ],
    },

    {
      path: ROUTES.CUSTOMERS_NEW_APPLICATION_COMPANY_OFFICIAL,
      element: <NewApplicationMainRepresentativeInfo isCompanyOfficial />,
      children: [
        {
          path: ROUTES.CUSTOMERS_NEW_APPLICATION_COMPANY_OFFICIAL_AGREEMENT,
          element: (
            <ApplicationAgreement
              applicationType={ApplicationType.COMPANY_OFFICIAL}
            />
          ),
        },
        {
          path: ROUTES.CUSTOMERS_NEW_APPLICATION_COMPANY_OFFICIAL_DOCUMENT,
          element: <CofDocumentSidepanel />,
        },
      ],
    },
  ],
};

export default NewAppliation;
